var map = {
	"./georgia+helvetica.png": "89d2",
	"./helvetica+georgia.png": "2f47",
	"./lato+lora.png": "52b7",
	"./lora+lato.png": "9ea4",
	"./palette-1.png": "332d",
	"./palette-2.png": "2823",
	"./palette-3.png": "0526",
	"./palette-4.png": "5b71",
	"./palette-5.png": "59a6",
	"./quattrocento+quattrocento_sans.png": "3806",
	"./quattrocento_sans+quattrocento.png": "99a4",
	"./roboto+roboto_slab.png": "2a6a",
	"./roboto_slab+roboto.png": "58f3",
	"./source_sans+source_serif.png": "0117",
	"./source_serif+source_sans.png": "f443",
	"./template-1.jpg": "303d",
	"./template-2.jpg": "52b4",
	"./template-3.jpg": "6cbf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0068";